// extracted by mini-css-extract-plugin
export default {"distCon":"Dist_distCon__oSeny","distConn":"Dist_distConn__jtK1R"};